import React, { ReactNode } from 'react';
import { PageContent } from '@cjdev-internal/visual-stack-x/components/PageContent';
import { Panel, Header } from '@cjdev-internal/visual-stack-x/Panel';

type PageLayoutProps = {
  toast?: JSX.Element;
  header: string;
  children: ReactNode;
  className?: string;
};


export const PageLayout = ({
  toast,
  header,
  children,
  className = ''
}: PageLayoutProps) => {
  return (
    <PageContent>
      {toast}
      <div className={className}>
        <div className={className ? `${className}-content` : ''}>
          <Panel>
            <Header>
              <h2>{header}</h2>
            </Header>
            {children}
          </Panel>
        </div>
      </div>
    </PageContent>
  );
};

export default PageLayout;